import React, { useContext } from "react";
import { EmptyState } from "./NoPrintersFound.style";
import { ApplicationContext } from "../../../../components/ApplicationProvider";

const NoPrintersFound: React.FC = () => {
    const { t } = useContext(ApplicationContext);

    return (
        <EmptyState data-testid="no-printers-found">
            <h3>{t("devices.no_printers_found")}</h3>
        </EmptyState>
    );
};

export default NoPrintersFound;
